var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.formKey === 'site_url')?_c('div',[_c('el-link',{attrs:{"href":_vm.formItem.value,"underline":false,"type":"primary","target":"_blank"}},[_vm._v(_vm._s(_vm.formItem.value))])],1):_vm._e(),(_vm.formKey === 'thumbnail')?_c('div',[_c('material-list',{attrs:{"form-item":_vm.formItem}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }